import {
  FETCH_DB_LOG_HEADERS,
  FETCH_DB_LOG_DETAIL,
} from './types';

import { fetchReducerFactory } from '../../../shared/store/fetchFactory';

const initialState = {
  dbLogHeaders: [],
  isLoadingDbLogHeaders: false,
  dbLogDetail: [],
  isLoadingDbLogDetail: false,
};

const databaseLogsReducer = fetchReducerFactory({
  [FETCH_DB_LOG_HEADERS]: 'DbLogHeaders',
  [FETCH_DB_LOG_DETAIL]: 'DbLogDetail',
}, initialState);

export default databaseLogsReducer;
